import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Accordion, Table, Loader, Icon, Grid} from 'semantic-ui-react';
import moment from 'moment';
import {dateFormatReservation} from '../../../../../common/constants/datesFormat';

class Models extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'activeIndex': 0,
    };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick = (e, titleProps) => {
    const {activeIndex} = this.state;
    const {index} = titleProps;
    const newIndex = activeIndex === index ? -1 : index;
    this.setState({'activeIndex': newIndex});
  };

  renderItems(list) {
    if (!list.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center'>No hay datos disponibles</Table.Cell>
        </Table.Row>
      );
    }
    return list.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center' width={4}>
            {element.model}
          </Table.Cell>
          <Table.Cell textAlign='center' width={4}>
            {element.chassis}
          </Table.Cell>
          <Table.Cell textAlign='center' width={4}>
            {element.motor}
          </Table.Cell>
          <Table.Cell textAlign='center' width={4}>
            {element.vehicle}
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  renderData() {
    const {loading, data} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderItems(data.models || []);
  }

  render() {
    const {activeIndex} = this.state;
    const {data} = this.props;

    return (
      <div>
        <Grid textAlign='left' className='models-title-section'>
          <Grid.Row>
            <Grid.Column width={2}>
              <div className='title'>Proveedor</div>
            </Grid.Column>
            <Grid.Column width={6}>{data.providerName}</Grid.Column>
            <Grid.Column width={4}>
              <div className='title'>Fecha Última Compra</div>
            </Grid.Column>
            <Grid.Column width={4}>
              {data.lastPurchase ?
                moment(data.lastPurchase).format(dateFormatReservation) :
                ''}
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={2}>
              <div className='title'>Marca</div>
            </Grid.Column>
            <Grid.Column width={6}>{data.brand}</Grid.Column>
            <Grid.Column width={4}>
              <div className='title'>Fecha Última Venta</div>
            </Grid.Column>
            <Grid.Column width={4}>
              {data.lastSale ?
                moment(data.lastSale).format(dateFormatReservation) :
                ''}
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Accordion fluid>
          <Accordion.Title
            active={activeIndex === 0}
            index={0}
            onClick={this.handleClick}
          >
            <Table striped className='toyota-grid'>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell textAlign='center' width={4}>
                    Modelo
                  </Table.HeaderCell>
                  <Table.HeaderCell textAlign='center' width={4}>
                    Chasis
                  </Table.HeaderCell>
                  <Table.HeaderCell textAlign='center' width={4}>
                    Motor
                  </Table.HeaderCell>
                  <Table.HeaderCell textAlign='center' width={3}>
                    Vehículo
                  </Table.HeaderCell>
                  <Table.HeaderCell textAlign='right' width={1}>
                    <Icon name='dropdown' />
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
            </Table>
          </Accordion.Title>

          <Accordion.Content active={activeIndex === 0}>
            <Table striped className='toyota-grid'>
              <Table.Body>{this.renderData(data.models || [])}</Table.Body>
            </Table>
          </Accordion.Content>
        </Accordion>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.parts.loading,
    'data': state.parts.partData,
  };
};

export default connect(mapStateToProps, {
})(Models);
